import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleService } from '../role/dummy-role-item';
@Component({
    selector: 'app-process',
    templateUrl: './process.component.html',
    styleUrls: ['./process.component.less'],
    standalone: false
})

export class ProcessComponent implements OnInit {
  items:any;
  term: string = "";

  constructor(private dialogRef: MatDialogRef<ProcessComponent>,public service:RoleService) {

  }
  ngOnInit(): void {
    this.items =this.service.roleList;
  }
  close() {
    this.dialogRef.close('close');
  }
  save() {
    this.dialogRef.close(this.items);
  }
  processCheck(chkValue:boolean,index:number) {
    debugger;
    this.service.roleList[index]["selected"] = chkValue;
    this.items=this.service.roleList;
  }

}
